import React, { useState } from "react";
import { TEAMS } from "../lib/site";

// Deterministic fallback colour from a team code so unknown teams still look distinct.
const COLORS = ["#1e60d1", "#0f9d58", "#7a0e1c", "#b45309", "#0b8f4e", "#5b21b6", "#0e7490", "#be123c"];
const colorFor = (code) => {
  const s = String(code || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length];
};

export default function TeamBadge({ code, team, size = 40 }) {
  const [imgOk, setImgOk] = useState(true);
  const known = TEAMS[code];
  const name = team?.name || known?.name || code;
  const img = team?.img;
  const color = known?.color || colorFor(code);

  if (img && imgOk) {
    return (
      <img
        src={img}
        alt={name}
        title={name}
        onError={() => setImgOk(false)}
        className="rounded-full object-cover bg-white shrink-0 ring-2 ring-white/10"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className="flex items-center justify-center rounded-full font-display font-bold text-white shrink-0 ring-2 ring-white/10"
      style={{ width: size, height: size, background: color, fontSize: size * 0.32 }}
      title={name}
    >
      {String(code || "?").slice(0, 3)}
    </div>
  );
}
